// Generated by https://quicktype.io

import {IdentityProvider} from "../../kamona/model/kamonal-model";

export interface ConfigsModel {
	unregisteredAccountLimits: MLiteAccountLimits;
	responseCode: string;
	posRequestExpiry: any;
	countries: Country[];
	mliteAccountLimits: MLiteAccountLimits;
	states: State[];
	localGovernments: LocalGovernment[];
	titles: Gender[];
	genders: Gender[];
	insuranceFee: number;
	banks: Bank[];
	allowedDisputeResponseCodes: string[];
	multipartSizeLimitData: MultipartSizeLimitData;
	kycMultipartSizeLimitData: MultipartSizeLimitData;
	cashoutFee: number;
	defaultProviders?:DefaultProvider;
	requireAgentBvn: boolean;
	enableAggregatorAgreement: boolean;
	enableAgentOnboardingBvnValidation: boolean;
	switchTransactionView: boolean;
	switchWalletView: boolean;
	clickHouseSearchDays: number;
	clickHouseSearchRange: number;
	rolezPrefixes: string[];
	maritalStatuses: string[];
	relationships: string[];
	religions: string[];
	kudaPrefixes: string[];
	insuranceNoDebitNotificationText: string;
	insuranceDebitNotificationText: string;
	switchOnManagerOverdraft: boolean;
	switchOnAggregatorOverdraft: boolean;
	switchOnSuperAggregatorOverdraft: boolean;
	switchOnAgentProtectedTransfer: boolean;
	employmentStatuses: string[];
	posRequestVideoLink: string;
	ninExpiryTime?:any;
	kycCorrectionExpiryTime: number;
	brmOnboardingPassportMaxFileSize: number;
	sourceOfWealthCategory: SourceOfWealthCategory[];
	occupations: Occupation[];
	incomeRevenueRanges: IncomeRevenueRange[];
	pepPositions?:string[];
	pepRelationships?:string[];
  maxExportStatementDurationInDays?: number;
  }

export interface SourceOfWealthCategory {
	id: number
	categoryName: string
	status: string
}

export interface Occupation {
	id: number
	occupations: string
	status: string
}

export interface IncomeRevenueRange {
	id: number
	minValue: number
	maxValue: number
	displayText: string
	status: string
}

export interface Occupation {
	id: number
	occupations: string
	status: string
}

export interface IncomeRevenueRange {
	id: number
	minValue: number
	maxValue: number
	displayText: string
	status: string
}

export interface Occupation {
	id: number
	occupations: string
	status: string
}

export interface IncomeRevenueRange {
	id: number
	minValue: number
	maxValue: number
	displayText: string
	status: string
}

export interface DefaultProvider {
	cacVerification:IdentityProvider;
	idVerification: IdentityProvider;
	liveliness: IdentityProvider;
}

export const DefaultProviders:DefaultProvider  = {
	cacVerification: IdentityProvider.METAMAP,
	idVerification: IdentityProvider.METAMAP,
	liveliness: IdentityProvider.SMILE_ID
}

export interface MLiteAccountLimits {
	DAILY_DEBIT: any;
	SINGLE_DEBIT: any;
}

export interface Bank {
	id: number;
	code: string;
	cbnCode?: string;
	name: string;
	status: string;
	dialCode?: string;
	state?: State;
	country?: Country;
}

export interface Country {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	code: string;
	name: string;
	dialCode: string;
	status: string;
}

export interface State {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	country: Country;
	code: string;
	name: string;
	enableWebDeposit: boolean;
	enableWebAirtimePurchase: boolean;
	enableWebBillPayment: boolean;
	status: string;
}

export interface LocalGovernment {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	state?: State;
	name: string;
	code: string;
	sanefCode?: string;
	status: string;
	dialCode?: string;
}

export interface Gender {
	id: number;
	name: string;
	status: string;
}

export interface MultipartSizeLimitData {
	maxFileSize: number;
	maxRequestSize: number;
}
